module.exports = __webpack_public_path__ + "img/questionnaireInvestigationBackImg.c962e591.jpg";